import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTabSwiper from 'eco-design/sections/eco-tab-swiper';
import styles from './index.module.scss';

export default function SectionA1() {
    const { t } = useLang('delta_pro_ultra.launch.detail.SectionA1');

    const items = [
        {
            tabValue: 'tab1',
            tabLabel: t('tab_label1'),
            bottomContent: t('tab_content1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750908688819/pc_tab1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750908688611/m_tab1.png',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', list_name: t('title') || 'none', button_name: t('tab_label1') },
        },
        {
            tabValue: 'tab2',
            tabLabel: t('tab_label2'),
            bottomContent: t('tab_content2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750399575583/pc_tab2.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750399574699/m_tab2.png',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', list_name: t('title') || 'none', button_name: t('tab_label2') },
        },
        {
            tabValue: 'tab3',
            tabLabel: t('tab_label3'),
            bottomContent: t('tab_content3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750399575772/pc_tab3.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750399574900/m_tab3.png',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', list_name: t('title') || 'none', button_name: t('tab_label3') },
        },
        {
            tabValue: 'tab4',
            tabLabel: t('tab_label4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1750399575104/pc_tab4.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1750399576161/m_tab4.png',
            tabDataLayer: { event: 'uaEvent', event_name: 'tab_click', list_name: t('title') || 'none', button_name: t('tab_label4') },
        },
    ];

    return (
        <div className={`page-sectionA1 ${styles.SectionA1}`}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.SectionA1}`}>
                <EcoTabSwiper theme="black" items={items} />
            </div>
        </div>
    );
}
